import { AnexoAlteracao } from "../../types";
import CardAnexo from "../../../../Compartilhado/Blocos/BlocoAnexos/CardAnexo";
import styled from "styled-components";
import { Plus, Minus } from "lucide-react";

const AnexoWrapper = styled.div<{ tipo: 'adicionado' | 'removido' }>`
    position: relative;
    margin-bottom: 16px;
    opacity: ${({ tipo }) => tipo === 'removido' ? 0.7 : 1};
    
    ${({ tipo }) => tipo === 'removido' && `
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border: 2px solid #E5293F;
            border-radius: 6px;
            pointer-events: none;
            z-index: 1;
        }
    `}
`;

const BadgeContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
`;

const Badge = styled.span<{ tipo: 'adicionado' | 'removido' }>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    background-color: ${({ tipo }) => tipo === 'adicionado' ? 'rgba(46, 134, 222, 0.1)' : 'rgba(229, 41, 63, 0.1)'};
    color: ${({ tipo }) => tipo === 'adicionado' ? 'var(--c2e86de)' : 'var(--ce5293f)'};
    
    svg {
        width: 12px;
        height: 12px;
    }
`;

interface BlocoAnexosProps {
    anexos: AnexoAlteracao[];
    onNavigateToFile?: (fileId: number) => void;
}

export default function BlocoAnexos({ anexos, onNavigateToFile }: BlocoAnexosProps) {
    if (anexos.length === 0) {
        return null;
    }

    const getTipoLabel = (tipo: 'adicionado' | 'removido'): string => {
        return tipo === 'adicionado' ? 'Adicionado' : 'Removido';
    };

    const getTipoIcon = (tipo: 'adicionado' | 'removido') => {
        return tipo === 'adicionado' ? Plus : Minus;
    };

    return (
        <div className="expanded-section">
            <h4 className="section-title">Anexos</h4>
            <div className="anexos-container">
                {anexos.map((anexoAlteracao, idx) => {
                    const key = `${anexoAlteracao.tipo}-${anexoAlteracao.anexo.id || anexoAlteracao.anexo.filename}-${idx}`;
                    const Icon = getTipoIcon(anexoAlteracao.tipo);
                    
                    return (
                        <AnexoWrapper key={key} tipo={anexoAlteracao.tipo}>
                            <BadgeContainer>
                                <Badge tipo={anexoAlteracao.tipo}>
                                    <Icon />
                                    {getTipoLabel(anexoAlteracao.tipo)}
                                </Badge>
                            </BadgeContainer>
                            <CardAnexo 
                                anexo={anexoAlteracao.anexo} 
                                onNavigateToFile={onNavigateToFile} 
                            />
                        </AnexoWrapper>
                    );
                })}
            </div>
        </div>
    );
}

